
import authService from '@/services/auth.service'
import TokenService from '@/services/token.service'
import { defineComponent } from 'vue'

export default defineComponent({
  mounted() {
    this.checkTokenValidity()
  },
  watch: {
    $route() {
      this.checkTokenValidity()
    }
  },
  methods: {
    async logOut() {
      try {
        await authService.logout()
        this.$router.push('/')
      } catch (ex) {
        console.log(ex)
        this.$toast.error(String(ex))
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace('/dashboard')
      }
    },
    checkTokenValidity() {
      const token = TokenService.getLocalAccessToken()
      if (!token) {
        this.redirectToLogin()
        return
      }
      if (this.isTokenExpired(token)) {
        TokenService.removeAllTokens()
        TokenService.removeUser()
        this.redirectToLogin()
      }
    },
    isTokenExpired(token: string) {
      try {
        const parts = token.split('.')
        if (parts.length !== 3) return false
        const payload = JSON.parse(this.base64UrlDecode(parts[1]))
        if (!payload || !payload.exp) return false
        const nowInSeconds = Math.floor(Date.now() / 1000)
        return payload.exp <= nowInSeconds
      } catch (ex) {
        return false
      }
    },
    base64UrlDecode(value: string) {
      const normalized = value.replace(/-/g, '+').replace(/_/g, '/')
      const padded = normalized.padEnd(normalized.length + (4 - (normalized.length % 4)) % 4, '=')
      return atob(padded)
    },
    redirectToLogin() {
      if (this.$route.path !== '/') {
        this.$router.replace('/')
      }
    }
  }
})
